<form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
  <div class="input-group gap-2 container">
    @if(showLabel) {
      <label for="alertDefaultTemplateID-field" class="form-check-label">Alert Template</label>
    }
    <select #alertDefaultTemplateSelect class="form-select" name="alertDefaultTemplateID-field" id="alertDefaultTemplateID-field" formControlName="alertDefaultTemplateID" (change)="selectOnChange($event, alertDefaultTemplateSelect.options.selectedIndex==undefined ? undefined : alertDefaultTemplateSelect.options[alertDefaultTemplateSelect.options.selectedIndex].text)">
      <option value=0>{{firstAlertDefaultTemplateOption}}</option>
      @for (object of getDropdownDataObjectArray(); track object.id) {
        <option [ngValue]="object.id">{{object.description}}</option>    
      }
    </select>
  </div>
</form>
